import { Col, Row } from "reactstrap";
import { Add, Cancel } from "../../../Constant";
import { Btn } from "../../../AbstractElements";
import { Link } from "react-router-dom";

export const ButtonSection = () => {
  return (
    <Row>
      <Col>
        <div className="text-end">
          <Btn type="submit" color="success" className="me-3">{Add}</Btn>
          <Link to={`${process.env.PUBLIC_URL}/project/project-list`}><Btn color="danger">{Cancel}</Btn></Link>
        </div>
      </Col>
    </Row>
  );
};
